import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthorizedBaseQuery } from 'store/authorizedBaseQuery';

import { hubsEndpointSchemas } from './hubs.schema-map';
import { transportOrdersEndpointSchemas } from './transportOrders.schema-map';
import { withOpenApiResponseValidation } from './validatingBaseQuery';

const endpointSchemas = {
    ...transportOrdersEndpointSchemas,
    ...hubsEndpointSchemas,
};

const baseQuery = withOpenApiResponseValidation(
    createAuthorizedBaseQuery(import.meta.env.VITE_MHS_BASE_URL),
    endpointSchemas
);

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery,
    tagTypes: ['TransportOrder', 'Hub'],
    endpoints: () => ({}),
});
